module.exports = __webpack_public_path__ + "static/media/FullIntroGREEK.70fd9d94.vtt";